import React from "react";

export const ServingSection = ({ children }) => {
    return (
        <div className="serving-info">
            <div className="row">{children}</div>
        </div>
    );
};

export const ServingColumn = ({ children }) => {
    return <div className="column">{children}</div>;
};
